module.exports = __webpack_public_path__ + "assets/b35fa5be57857fa39760bc863bc91843.mp3";